import type { MessageDescriptor } from "@lingui/core";
import { CATEGORY_NAME_MESSAGES } from "./category-names";

/**
 * NARROW signature on purpose, same as `useI18n().t`: only `MessageDescriptor`.
 * Allowing `string` reopens the door to text that the extractor does not see and remains
 * in English across the 10 non-English locales without any gate signaling it.
 */
type Translate = (msg: MessageDescriptor) => string;

/** Visible name: seeds are translated by name_key; user-created, literally. */
export function categoryDisplayName(
  t: Translate,
  row: { name: string | null; name_key?: string | null },
): string {
  const descriptor = row.name_key ? CATEGORY_NAME_MESSAGES[row.name_key] : undefined;
  if (descriptor) {
    return t(descriptor);
  }
  return row.name ?? "";
}
